import { render } from "./AppModal.vue?vue&type=template&id=3bf3040c&ts=true"
import script from "./AppModal.vue?vue&type=script&lang=ts"
export * from "./AppModal.vue?vue&type=script&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=3bf3040c&lang=scss"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__